export default ( apiInstance: API.Client ) => ( entry: any ): Promise<string> => (
  apiInstance.Entity.collection( 'patrolCache' ).add( entry )
);